import { Button } from '@/components/ui/button';
import { ArrowRight, Calculator } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BlogCTA({ variant = 'estimation' }) {
  const navigate = useNavigate();

  if (variant === 'estimation') {
    return (
      <div className="my-16 bg-gradient-to-br from-[#8A9474] to-[#7A8464] rounded-2xl p-8 md:p-12 text-white shadow-xl">
        <div className="max-w-3xl mx-auto text-center">
          <Calculator className="h-12 w-12 mx-auto mb-6" />
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Combien pourriez-vous gagner avec votre bien ?
          </h3>
          <p className="text-lg mb-8 text-white/90">
            Obtenez une estimation gratuite et personnalisée de vos revenus potentiels en location saisonnière. Sans engagement, en 2 minutes.
          </p>
          <Button
            onClick={() => navigate('/estimation')}
            size="lg"
            className="bg-white text-[#8A9474] hover:bg-gray-100 px-8 py-6 text-lg font-semibold"
            data-testid="blog-cta-estimation"
          >
            Estimer mes revenus gratuitement
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    );
  }

  // variant === 'contact'
  return (
    <div className="my-16 bg-white border-2 border-[#8A9474] rounded-2xl p-8 md:p-12 shadow-lg">
      <div className="max-w-3xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-[#2B2B2B] mb-4">
              Besoin de conseils personnalisés ?
            </h3>
            <p className="text-lg text-[#4A4A4A] mb-6">
              Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions sur la gestion locative saisonnière.
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2 text-[#4A4A4A]">
                <div className="w-2 h-2 bg-[#8A9474] rounded-full"></div>
                <span>Accompagnement personnalisé</span>
              </li>
              <li className="flex items-center gap-2 text-[#4A4A4A]">
                <div className="w-2 h-2 bg-[#8A9474] rounded-full"></div>
                <span>Réponse sous 24h</span>
              </li>
              <li className="flex items-center gap-2 text-[#4A4A4A]">
                <div className="w-2 h-2 bg-[#8A9474] rounded-full"></div>
                <span>Consultation gratuite</span>
              </li>
            </ul>
          </div>
          <div className="text-center md:text-right">
            <Button
              onClick={() => navigate('/estimation')}
              size="lg"
              className="bg-[#8A9474] hover:bg-[#7A8464] text-white px-8 py-6 text-lg font-semibold mb-4 w-full md:w-auto"
              data-testid="blog-cta-contact-primary"
            >
              Demander une estimation
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <p className="text-sm text-[#6B6B6B]">
              Sans engagement • Réponse rapide
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
